import { render, staticRenderFns } from "./edit.vue?vue&type=template&id=6f0c59ab&scoped=true"
import script from "./edit.vue?vue&type=script&lang=js"
export * from "./edit.vue?vue&type=script&lang=js"
import style0 from "./edit.vue?vue&type=style&index=0&id=6f0c59ab&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f0c59ab",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Workplace\\vueProject\\edu_aim\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6f0c59ab')) {
      api.createRecord('6f0c59ab', component.options)
    } else {
      api.reload('6f0c59ab', component.options)
    }
    module.hot.accept("./edit.vue?vue&type=template&id=6f0c59ab&scoped=true", function () {
      api.rerender('6f0c59ab', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/admin/edit.vue"
export default component.exports